package com.shadowings.gero.presentation.viewmodel

import androidx.lifecycle.SavedStateHandle
import androidx.lifecycle.ViewModel
import androidx.lifecycle.viewModelScope
import com.shadowings.gero.data.repository.Hiero
import com.shadowings.gero.domain.model.IExplanation
import com.shadowings.gero.domain.model.UserData
import com.shadowings.gero.presentation.model.Word
import com.shadowings.gero.domain.repository.DatabaseRepository
import com.shadowings.gero.domain.repository.LessonContentRepository
import com.shadowings.gero.domain.repository.UserDataRepository
import com.shadowings.gero.util.systemLanguageCode
import kotlinx.coroutines.Dispatchers
import kotlinx.coroutines.flow.SharingStarted
import kotlinx.coroutines.flow.StateFlow
import kotlinx.coroutines.flow.map
import kotlinx.coroutines.flow.stateIn
import kotlinx.coroutines.launch

import com.shadowings.gero.domain.repository.AnalyticsRepository

class ExplanationViewModel(
    savedStateHandle: SavedStateHandle,
    private val lessonContentRepository: LessonContentRepository,
    private val userDataRepository: UserDataRepository,
    private val databaseRepository: DatabaseRepository,
    private val analyticsRepository: AnalyticsRepository,
) : ViewModel() {

    val lessonId: String = savedStateHandle.get<String>("lessonId") ?: ""

    init {
        analyticsRepository.logStartLesson(lessonId)
    }

    val userData: StateFlow<UserData> = userDataRepository.userData
        .stateIn(viewModelScope, SharingStarted.Eagerly, UserData())

    val hieros: List<Hiero> = databaseRepository.hieros
    val words: List<Word> = databaseRepository.words

    val content: StateFlow<List<IExplanation>> = userData.map { userData ->
        val languageCode = userData.language.ifBlank { systemLanguageCode() }
        lessonContentRepository.getExplanationContent(
            lessonId,
            hieros,
            words,
            languageCode
        )
    }.stateIn(viewModelScope, SharingStarted.Eagerly, emptyList())

    fun onExplanationCompleted() =
        viewModelScope.launch(Dispatchers.Default) {
            userDataRepository.setLessonCompleted(lessonId)
        }
}

